import React from 'react'

export const CmsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 76 85"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M60.4,29.9c-2,0-3.8,0.2-5.5,0.8c2.1,1.7,3.9,3.8,5.4,6.1h0.1c7,0,12.7,5.7,12.7,12.7s-5.7,12.7-12.7,12.7c-1.7,0-3.5-0.3-5-1c0.9-1.3,1.7-2.7,2.3-4c0.2-0.6,0.5-1,0.6-1.6c0.6-1.8,0.9-3.9,0.9-6c0-10.8-8.8-19.6-19.6-19.6S20,38.7,20,49.5s8.8,19.6,19.6,19.6c2,0,3.8-0.2,5.5-0.8c-2.1-1.7-3.9-3.8-5.4-6.1h-0.1c-7,0-12.7-5.7-12.7-12.7s5.7-12.7,12.7-12.7c1.7,0,3.5,0.3,5.1,1c-2.4,3.2-3.9,7.3-3.9,11.7c0,10.8,8.8,19.6,19.6,19.6S80,60.3,80,49.5S71.2,29.9,60.4,29.9z" />
  </svg>
)
